import { render, staticRenderFns } from "./SearchMyPosition.vue?vue&type=template&id=245d8df0"
import script from "./SearchMyPosition.vue?vue&type=script&lang=js"
export * from "./SearchMyPosition.vue?vue&type=script&lang=js"
import style0 from "./SearchMyPosition.vue?vue&type=style&index=0&id=245d8df0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports